module.exports = __webpack_public_path__ + "img/nfstQRcode.094ff1ee.png";